import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(marketing)/soulmate-test/page.tsx");
